import React from 'react';
import {
  StyledContributorRow,
  StyledContributorsView
} from './ContributorsView.style';
import StyledAvatar from 'components/StyledAvatar';
import { StyledColumnHeader } from '../SyncGitTeamsForm.style';
import Icon from 'components/base/Icon';
import _ from 'lodash';

const TEAM_NAME_MAX_LENGTH = 25;

const ContributorRow = ({ contributor }) => {
  const contributorName = _.get(contributor, 'name') || 'N/A';
  return (
    <StyledContributorRow>
      <StyledAvatar size='1.8rem' avatar={{ url: contributor.avatarUrl }} />
      <div className='contributor-name'>{contributorName}</div>
    </StyledContributorRow>
  );
};

const ContributorsView = ({ selectedTeam, onCancel = _.noop }) => {
  if (!selectedTeam) return null;

  const contributors = _.get(selectedTeam, 'members', []); //use react-window List for lazy load UI
  const teamName = _.get(selectedTeam, 'name', '');
  const isTeamNameTooLong = _.size(teamName) > TEAM_NAME_MAX_LENGTH;
  const teamNameHeader = isTeamNameTooLong
    ? `${teamName.slice(0, TEAM_NAME_MAX_LENGTH)}...`
    : teamName;

  return (
    <StyledContributorsView data-cy='contributors-view'>
      <StyledColumnHeader>
        {teamNameHeader} ({contributors.length})
        <Icon name='Close' onClick={onCancel} />
      </StyledColumnHeader>
      <main className='contributor-list'>
        {contributors.map(contributor => (
          <ContributorRow key={contributor.id} contributor={contributor} />
        ))}
      </main>
    </StyledContributorsView>
  );
};

export default ContributorsView;
